import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Form, Table } from "react-bootstrap";
import ReactDatetime from "react-datetime";
import { isEmpty, isBoolean, isNumber } from "lodash";
import { FileUploadField, capitalizeFirstLetter } from '../Shared/Helpers';
import CustomSweetAlert from 'components/Shared/CustomSweetAlert';
import moment from 'moment';

const StepFour = ({ handleNext, handleBack, storedData }) => {
    const apiURL = process.env.REACT_APP_JOB_URL;
    const [formData, setFormData] = useState({
        fileP45: null
    });
    const [isHaveP45, setIsHasP45] = useState(true);
    const [errors, setErrors] = useState({});
    const [alert, setAlert] = useState([]);
    const [startDate, setStartDate] = useState();
    const [dob, setDob] = useState();

    useEffect(() => {
        window.scrollTo(0, 0);
        if (storedData) {
            setFormData(prevState => ({
                ...prevState,
                hasP45Doc: storedData?.hasP45Doc,
                hmrcDetails: storedData?.storedData || null
            }));
        }
    }, []);

    const validateForm = (formData) => {
        const { fileP45 } = formData;
        if (isHaveP45 === true) {
            return { fileP45: isEmpty(fileP45) && 'File P45 is required', };
        }

        const errors = {
            lastName: isEmpty(formData?.lastName) && 'Last name is required',//1
            firstName: isEmpty(formData?.firstName) && 'First name is required',//2
            sex: !isNumber(formData?.sex) && 'Your sex is required',//3
            dateOfBirth: isEmpty(dob) && 'Date of birth is required',//4
            homeAddress: isEmpty(formData?.homeAddress) && 'Home address is required',//5
            postcode: isEmpty(formData?.postcode) && 'Postcode is required',//5
            country: isEmpty(formData?.country) && 'Country is required',//5
            nationalInsuranceNo: isEmpty(formData?.nationalInsuranceNo) && 'Insurance number is required',//6
            employmentStartDate: isEmpty(startDate) && 'Start date is required', // 7
            haveOtherJob: !isBoolean(formData?.haveOtherJob) && 'This field is required',// 8
            receivePaymentsFromPension: !isBoolean(formData?.receivePaymentsFromPension) && 'This field is required',//9
            receivePaymentsThisTaxYear: !isBoolean(formData?.receivePaymentsThisTaxYear) && 'This field is required', // 10
            haveStudentLoan: !isBoolean(formData?.haveStudentLoan) && 'This field is required', // 11
            selectedStatement: !isNumber(formData?.selectedStatement) && 'This field is required', // Statement
        };
        if (!isEmpty(formData?.haveStudentLoan) && formData?.haveStudentLoan === true) {
            errors.requireToSelectPlan = !isBoolean(formData?.requireToSelectPlan) && 'This field is required';// 12
            errors.selectedPlan = !isNumber(formData?.selectedPlan) && 'This field is required'; // 13
        }
        return errors;
    }

    const handlePostData = (data) => {
        data.dateOfBirth = dob;
        data.employmentStartDate = startDate;
        if (isHaveP45 === true) {
            return data.fileP45?.Base64 ? data.fileP45.Base64 : "";
        }
        delete data.fileP45;
        delete data.hasP45Doc;
        delete data.hmrcDetails;
        return data;
    }

    const handleSubmit = async () => {
        try {
            const errors = validateForm(formData);

            if (!Object.values(errors).some(Boolean)) {
                setErrors([]);
                setAlert(CustomSweetAlert({ type: "loading" }));
                const postData = handlePostData(formData);
                const url = `/HRInduction/${isHaveP45 ? "SubmitP45" : "SubmitHMRCStarterPack"}?inductionId=${storedData?.inductionId}&employeeId=${storedData?.employeeId}&pin=${storedData?.pin}`;
                const method = `post`;
                const response = await fetch(apiURL + url, {
                    method,
                    headers: [
                        ["Content-Type", "application/json"],
                        ["Content-Type", "text/plain"]
                    ],
                    body: JSON.stringify(postData),
                });
                if (response.status === 200) {
                    handleNext(postData);
                } else {
                    showErrorAlert(`Save Previous Employment failed`);
                }
            } else {
                setErrors(errors);
                window.scrollTo(0, 0);
            }
        } catch (e) {
            showErrorAlert(`Something went wrong`);
        }
    }

    const handleChangeData = (value, name) => {
        setFormData({ ...formData, [name]: value });

    }

    const handleFileUpload = (event) => {
        const newFile = event.target.files[0];
        const maxSize = 5 * 1024 * 1024; // 5 MB
        const name = event.target.name;
        if (newFile && newFile.size > maxSize) {
            alert("File size is too large. Maximum file size allowed is 5MB.");
            event.target.value = null; // clear the file input
            return;
        }

        const reader = new FileReader();

        reader.onload = function (event) {
            const base64String = btoa(
                new Uint8Array(event.target.result)
                    .reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
            const documentFilename = newFile.name;
            setFormData({
                ...formData,
                [name]: {
                    Base64: base64String,
                    DocumentFilename: documentFilename
                }
            });
        };

        reader.readAsArrayBuffer(newFile);
    }

    const handleRemoveFile = (name) => {
        setFormData({
            ...formData,
            [name]: null
        });
    };

    const handleNotHaveP45 = () => setIsHasP45(!isHaveP45);

    const showErrorAlert = (message) => setAlert(CustomSweetAlert({
        type: "error", title: "Error", message: message,
        onConfirm: () => {
            hideAlert();
        }, showCancel: false
    }));

    const hideAlert = () => setAlert(null);


    return (
        <>
            {alert}
            <Row>
                <Col sm={12} md={12}>
                    <h2 >4. Previous Employment</h2>
                    <p style={{ marginTop: '-15px' }}>Please fill out all required fields</p>
                </Col>

            </Row>

            <Col sm={12} md={12} className='text-left py-1'>
                <h5 className='my-0'>1. P45 (from previous employer) (upload) or HMRC Starter checklist (complete)</h5>
                <div>
                    <h5 className=''>a. Use the HMRC Starter checklist if:</h5>
                    <ul>
                        <li><h5 className='fw-100'>You do not have a P45 (Please note the P45 must have been issued in the tax year that your employment is commencing ie between 6th April to 5th April)</h5></li>
                        <li><h5 className='fw-100'>Your personal details are different to those shown on your P45</h5></li>
                        <li><h5 className='fw-100'>You have a student or postgraduate loan</h5></li>
                    </ul>
                </div>
            </Col>
            <FileUploadField
                label="Upload file P45"
                name="fileP45"
                documentFilename={formData.fileP45?.DocumentFilename}
                handleFileUpload={handleFileUpload}
                handleRemoveFile={handleRemoveFile}
                error={errors.fileP45}
                disabled={isHaveP45 === false}
            />
            <Col sm={12} md={12} >
                <Form.Group className='d-flex'>
                    <Form.Check.Label style={{ textAlign: 'left' }}>
                        <Form.Check.Input
                            type="checkbox"
                            checked={!isHaveP45}
                            onChange={handleNotHaveP45}
                        ></Form.Check.Input>
                        <span className="form-check-sign" style={{ paddingRight: "10px" }}></span>
                        <><span>Don't have a P45? Fill in the steps below</span><span className="star">*</span>
                        </>
                    </Form.Check.Label>
                </Form.Group>
                {errors.hasP45Doc && <Form.Text className="text-danger"> <span className="star">*</span> {errors.hasP45Doc} </Form.Text>}
            </Col>
            {isHaveP45 === false && <>
                <hr />
                <Row>
                    <Col sm={12} md={12}>
                        <h2 className='text-left'>Employee's personal details:</h2>
                    </Col>
                </Row>
                <Row>
                    <Col md="6" xs="12">
                        <Col sm={12} className="my-1">
                            <h5>Last Name<span className="star">*</span></h5>
                            <Form.Group>
                                <Form.Control type="text"
                                    value={formData?.hmrcDetails?.lastName}
                                    onChange={(e) => handleChangeData(capitalizeFirstLetter(e.target.value), "lastName")}
                                    className={errors.lastName ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                />
                                {errors.lastName && <Form.Text className="text-danger"> <span className="star">*</span> {errors.lastName} </Form.Text>}
                            </Form.Group>
                        </Col>
                        <Col sm={12} className="my-1">
                            <h5>First Name<span className="star">*</span></h5>
                            <Form.Group>
                                <Form.Control type="text"
                                    value={formData?.hmrcDetails?.firstName}
                                    onChange={(e) => handleChangeData(capitalizeFirstLetter(e.target.value), "firstName")}
                                    className={errors.firstName ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                />
                                {errors.firstName && <Form.Text className="text-danger"> <span className="star">*</span> {errors.firstName} </Form.Text>}
                            </Form.Group>
                            <h5 className='d-flex fw-100'>* Do not enter initials or shortened names for example, Jim for James or Liz for Elizabeth</h5>
                        </Col>
                        <Col sm={12} className="my-1">
                            <h5>What is your sex ?<span className="star">*</span></h5>
                            <h5 className='fw-100'>As shown on your birth certificate or sex recognition certificate</h5>
                            <Form.Group className='d-flex justify-content-around'>
                                <Form.Check>
                                    <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px' }}>
                                        <Form.Check.Input
                                            type="radio"
                                            name="sex"
                                            id="male"
                                            onChange={(e) => handleChangeData(1, "sex")}
                                        ></Form.Check.Input>
                                        <><span>Male</span>
                                        </>
                                    </Form.Check.Label>
                                </Form.Check>
                                <Form.Check>
                                    <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px' }}>
                                        <Form.Check.Input
                                            type="radio"
                                            name="sex"
                                            id="female"
                                            onChange={(e) => handleChangeData(1, "sex")}

                                        ></Form.Check.Input>
                                        <><span>Famale</span>
                                        </>
                                    </Form.Check.Label>
                                </Form.Check>
                            </Form.Group>
                            {errors.sex && <Form.Text className="text-danger"> <span className="star">*</span> {errors.sex} </Form.Text>}
                        </Col>
                        <Col sm={12} className="my-1">
                            <h5>Date of birth<span className="star">*</span></h5>
                            <Form.Group>
                                <ReactDatetime
                                    inputProps={{
                                        className: errors.dateOfBirth ? "form-control is-invalid custom-input" : "form-control custom-input",
                                        name: "dateOfBirth",
                                        disabled: false,
                                        onKeyDown: (e) => { e.preventDefault() }
                                    }}
                                    value={dob}
                                    onChange={(date) => setDob(date.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"))}
                                    timeFormat={false}
                                    dateFormat="DD/MM/YYYY"
                                />
                            </Form.Group>
                            {errors.dateOfBirth && <Form.Text className="text-danger"> <span className="star">*</span> {errors.dateOfBirth} </Form.Text>}
                        </Col>
                        <Col sm={12} className="my-1">
                            <h5>Do you have another job ?<span className="star">*</span></h5>
                            <Form.Group>
                                <Form.Check className='d-flex'>
                                    <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px' }}>
                                        <Form.Check.Input
                                            type="radio"
                                            name="haveOtherJob"
                                            onChange={(e) => handleChangeData(true, "haveOtherJob")}
                                        ></Form.Check.Input>
                                        <><h5 className='my-1 fw-100'>Yes (Put an 'X' in the statement C box below)</h5>
                                        </>
                                    </Form.Check.Label>
                                </Form.Check>
                                <Form.Check className='d-flex'>
                                    <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px' }}>
                                        <Form.Check.Input
                                            type="radio"
                                            name="haveOtherJob"
                                            onChange={(e) => handleChangeData(false, "haveOtherJob")}
                                        ></Form.Check.Input>
                                        <><h5 className='my-1 fw-100'>No (Go to question 9)</h5>
                                        </>
                                    </Form.Check.Label>
                                </Form.Check>
                            </Form.Group>
                            {errors.haveOtherJob && <Form.Text className="text-danger"> <span className="star">*</span> {errors.haveOtherJob} </Form.Text>}
                        </Col>

                        <Col sm={12} className="my-1">
                            <h5>Do you have receive payments from a State, workplace or private pension ?<span className="star">*</span></h5>
                            <Form.Group>
                                <Form.Check className='d-flex'>
                                    <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px' }}>
                                        <Form.Check.Input
                                            type="radio"
                                            name="receivePaymentsFromPension"
                                            onChange={(e) => handleChangeData(true, "receivePaymentsFromPension")}
                                        ></Form.Check.Input>
                                        <><h5 className='my-1 fw-100'>Yes (Put an 'X' in the statement C box below)</h5>
                                        </>
                                    </Form.Check.Label>
                                </Form.Check>
                                <Form.Check className='d-flex'>
                                    <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px' }}>
                                        <Form.Check.Input
                                            type="radio"
                                            name="receivePaymentsFromPension"
                                            onChange={(e) => handleChangeData(false, "receivePaymentsFromPension")}
                                        ></Form.Check.Input>
                                        <><h5 className='my-1 fw-100'>No (Go to question 10)</h5>
                                        </>
                                    </Form.Check.Label>
                                </Form.Check>
                            </Form.Group>
                            {errors.receivePaymentsFromPension && <Form.Text className="text-danger"> <span className="star">*</span> {errors.receivePaymentsFromPension} </Form.Text>}
                        </Col>
                    </Col>
                    <Col md="6" xs="12">
                        <Col sm={12} className="my-1">
                            <h5 className="">Home address:<span className="star">*</span></h5>
                            <Form.Group>
                                <Form.Control type="text"
                                    placeholder='Home address'
                                    value={formData?.hmrcDetails?.homeAddress}
                                    onChange={(e) => handleChangeData(capitalizeFirstLetter(e.target.value), "homeAddress")}
                                    className={errors.homeAddress ? "form-control is-invalid custom-input mb-2" : "form-control custom-input mb-2"}
                                />
                                {errors.homeAddress && <Form.Text className="text-danger"> <span className="star">*</span> {errors.homeAddress} </Form.Text>}

                                <Form.Control type="text"
                                    placeholder='Postcode'
                                    value={formData?.hmrcDetails?.postcode}
                                    onChange={(e) => handleChangeData(capitalizeFirstLetter(e.target.value), "postcode")}
                                    className={errors.postcode ? "form-control is-invalid custom-input mb-2" : "form-control custom-input mb-2"}
                                />
                                {errors.postcode && <Form.Text className="text-danger"> <span className="star">*</span> {errors.postcode} </Form.Text>}

                                <Form.Control type="text"
                                    placeholder='Country'
                                    value={formData?.hmrcDetails?.country}
                                    onChange={(e) => handleChangeData(capitalizeFirstLetter(e.target.value), "country")}
                                    className={errors.country ? "form-control is-invalid custom-input mb-2" : "form-control custom-input mb-2"}
                                />
                                {errors.country && <Form.Text className="text-danger"> <span className="star">*</span> {errors.country} </Form.Text>}
                            </Form.Group>
                        </Col>
                        <Col sm={12} className="my-1">
                            <h5>National Insurance number(if known)</h5>
                            <Form.Group>
                                <Form.Control type="text"
                                    value={formData?.hmrcDetails?.nationalInsuranceNo}
                                    onChange={(e) => {
                                        const updatedValue = e.target.value;
                                        setFormData(prevState => ({
                                            ...prevState,
                                            nationalInsuranceNo: capitalizeFirstLetter(updatedValue),
                                        }));
                                    }}
                                    className={errors.nationalInsuranceNo ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                />
                                {errors.nationalInsuranceNo && <Form.Text className="text-danger"> <span className="star">*</span> {errors.nationalInsuranceNo} </Form.Text>}
                            </Form.Group>
                        </Col>
                        <Col sm={12} className="my-1">
                            <h5>Employeement start date (DD/MM/YYYY)<span className="star">*</span></h5>
                            <Form.Group>
                                <ReactDatetime
                                    inputProps={{
                                        className: errors.employmentStartDate ? "form-control is-invalid custom-input" : "form-control custom-input",
                                        name: "employmentStartDate",
                                        disabled: false,
                                        onKeyDown: (e) => { e.preventDefault() }
                                    }}
                                    value={startDate}
                                    onChange={(date) => setStartDate(date.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"))}
                                    timeFormat={false}
                                    dateFormat="DD/MM/YYYY"
                                />
                                {errors.employmentStartDate && <Form.Text className="text-danger"> <span className="star">*</span> {errors.employmentStartDate} </Form.Text>}
                            </Form.Group>
                        </Col>
                        <Col sm={12} className="my-1">
                            <h5>Since 6 April have you receive payments from: ?<span className="star">*</span></h5>
                            <div className='d-flex justify-content-start'>
                                <ul className='my-0'>
                                    <li><h5 className='fw-100'>Another job which has ended or any of the following taxable benefits</h5></li>
                                    <li><h5 className='fw-100'>Jobseeker's Allowance (JSA)</h5></li>
                                    <li><h5 className='fw-100'>Employeement and Support Allowance (ESA)</h5></li>
                                    <li><h5 className='fw-100'>Incapacity Benefit</h5></li>
                                </ul>
                            </div>
                            <Form.Group>
                                <Form.Check className='d-flex'>
                                    <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px' }}>
                                        <Form.Check.Input
                                            type="radio"
                                            name="receivePaymentsThisTaxYear"
                                            onChange={(e) => handleChangeData(true, "receivePaymentsThisTaxYear")}
                                        ></Form.Check.Input>
                                        <><h5 className='my-1 fw-100'>Yes (Put an 'X' in the statement B box below)</h5>
                                        </>
                                    </Form.Check.Label>
                                </Form.Check>
                                <Form.Check className='d-flex'>
                                    <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px' }}>
                                        <Form.Check.Input
                                            type="radio"
                                            name="receivePaymentsThisTaxYear"
                                            onChange={(e) => handleChangeData(false, "receivePaymentsThisTaxYear")}
                                        ></Form.Check.Input>
                                        <><h5 className='my-1 fw-100'>No (Put an 'X' in the statement A box below)</h5>
                                        </>
                                    </Form.Check.Label>
                                </Form.Check>
                                {errors.receivePaymentsThisTaxYear && <Form.Text className="text-danger"> <span className="star">*</span> {errors.receivePaymentsThisTaxYear} </Form.Text>}
                            </Form.Group>
                            <h5 className='text-center fw-100'>For more information about tax codes, go to{' '}
                                <a href='https://www.gov.uk/tax-codes' rel="noreferrer" target="_blank" >www.gov.uk/tax-codes</a>
                            </h5>
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} className="my-1">
                        <Table striped bordered>
                            <thead>
                                <tr>
                                    <th>
                                        <p className='m-0'><h5 className='text-center text-dark m-0 my-1'>Statement A </h5></p>
                                        <Form.Check className='text-center p-0'>
                                            <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px' }}>
                                                <Form.Check.Input
                                                    type="radio"
                                                    name="selectedStatement"
                                                    onChange={(e) => handleChangeData(1, "selectedStatement")}
                                                ></Form.Check.Input>
                                            </Form.Check.Label>
                                        </Form.Check>
                                        <p className='m-0 text-dark fw-bold'>Current personal allowance</p>
                                    </th>
                                    <th>
                                        <p className='m-0'><h5 className='text-center text-dark m-0 my-1'>Statement B</h5></p>
                                        <Form.Check className='text-center p-0'>
                                            <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px' }}>
                                                <Form.Check.Input
                                                    type="radio"
                                                    name="selectedStatement"
                                                    onChange={(e) => handleChangeData(2, "selectedStatement")}
                                                ></Form.Check.Input>
                                            </Form.Check.Label>
                                        </Form.Check>
                                        <p className='m-0 text-dark fw-bold'>Current personal allowance on a Week 1 / Month 1 basis </p>
                                    </th>
                                    <th>
                                        <p className='m-0'><h5 className='text-center text-dark m-0 my-1'>Statement C</h5></p>
                                        <Form.Check className='text-center p-0'>
                                            <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px' }}>
                                                <Form.Check.Input
                                                    type="radio"
                                                    name="selectedStatement"
                                                    onChange={(e) => handleChangeData(3, "selectedStatement")}
                                                ></Form.Check.Input>
                                            </Form.Check.Label>
                                        </Form.Check>
                                        <p className='m-0 text-dark fw-bold'>Tax Code BR</p>
                                    </th>
                                </tr>

                                {errors.selectedStatement &&
                                    <tr>
                                        <td colSpan={3}><Form.Text className="text-danger"> <span className="star">*</span> {errors.selectedStatement} </Form.Text></td>
                                    </tr>
                                }
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <p><h5><strong>Key</strong></h5></p>
                                        <p className='text-left' style={{ paddingLeft: '16px' }}>This is my first job since 6 April and since the 6 April I have not received payments from any of the following:</p>
                                        <div>
                                            <ul>
                                                <li className='text-left'>Jobseeker's Allowance</li>
                                                <li className='text-left'>Employment and Support Allowance</li>
                                                <li className='text-left'>Incapacity Benefit</li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td>
                                        <p><h5><strong>Key</strong></h5></p>
                                        <p className='text-left' style={{ paddingLeft: '16px' }}>Since 6 April I have had another job but I do not have a P45.And / or since the 6 April I have received payments from any of the following:</p>
                                        <div className='d-flex justify-content-start'>
                                            <ul >
                                                <li className='text-left'>Jobseeker's Allowance</li>
                                                <li className='text-left'>Employment and Support Allowance</li>
                                                <li className='text-left'>Incapacity Benefit</li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td style={{ verticalAlign: 'top' }}>
                                        <p><h5><strong>Key</strong></h5></p>
                                        <p className='text-left' style={{ paddingLeft: '16px' }}>I have another job and / or I am in receipt of a State, workplace or private pension.</p>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr >
                                    <td colSpan={3}>
                                        <p><h5><strong>Key</strong></h5></p>
                                        <ul style={{ listStyleType: 'none' }} >
                                            <li className='text-left'>Jobseeker's Allowance (JSA) is an unemployment benefit which can be claimed while looking for work.</li>
                                            <li className='text-left'>Employment and Support Allowance(ESA) is a benefit which can be claimed if you have a disability or health condition that affects how much you can work.</li>
                                            <li className='text-left'>Incapacity Benefit is help if you could not work because of an illness or disability before 31 January 2011.</li>
                                            <li className='text-left'>State Pension is a pension paid when you reach State Pension age.</li>
                                            <li className='text-left'>Workplace pension is a pension which was arranged by your employer and is being paid to you.</li>
                                            <li className='text-left'>Private pension is a pension arranged by you and is being paid to you.</li>
                                            <li className='text-left'>Please note that no other Government or HMRC paid benefits need to be considered when completing this form.</li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col sm={6} xs={12}>
                        <Col sm={12} className="my-1">
                            <h5>Do you have a student or postgraduate loan?</h5>
                            <Form.Group>
                                <Form.Check className='d-flex'>
                                    <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px' }}>
                                        <Form.Check.Input
                                            type="radio"
                                            name="haveStudentLoan"
                                            onChange={() => handleChangeData(true, "haveStudentLoan")}
                                        ></Form.Check.Input>
                                        <><h5 className='fw-100 my-1'>Yes (Go to question 12)</h5>
                                        </>
                                    </Form.Check.Label>
                                </Form.Check>
                                <Form.Check className='d-flex'>
                                    <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px' }}>
                                        <Form.Check.Input
                                            type="radio"
                                            name="haveStudentLoan"
                                            onChange={() => handleChangeData(false, "haveStudentLoan")}
                                        ></Form.Check.Input>
                                        <><h5 className='fw-100 my-1'>No (Go straight to the Declaration)</h5>
                                        </>
                                    </Form.Check.Label>
                                </Form.Check>
                            </Form.Group>
                            {errors.haveStudentLoan && <Form.Text className="text-danger"> <span className="star">*</span> {errors.haveStudentLoan} </Form.Text>}
                        </Col>
                        <Col sm={12} className="my-1">
                            <h5>Do any of the following statements apply:</h5>
                            <div>
                                <ul>
                                    <li className='text-left'><h5 className='fw-100 my-1'>you're still studying on a course that your student loan relates to</h5></li>
                                    <li className='text-left fw-100'><h5 className='fw-100 my-1'>you completed or left your course after the start of the current tax year, which started on 6 April</h5></li>
                                    <li className='text-left fw-100'><h5 className='fw-100 my-1'>you've already repaid your loan in full</h5></li>
                                    <li className='text-left fw-100'><h5 className='fw-100 my-1'>you're paying the Student Loans Company by Direct Debit from your bank to manage your end of loan repayments</h5></li>
                                </ul>
                            </div>
                            <Form.Group>
                                <Form.Check className='d-flex'>
                                    <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px' }}>
                                        <Form.Check.Input
                                            type="radio"
                                            name="requireToSelectPlan"
                                            onChange={() => handleChangeData(true, "requireToSelectPlan")}
                                        ></Form.Check.Input>
                                        <><h5 className='fw-100 my-1'>Yes (Go straight to the Declaration )</h5>
                                        </>
                                    </Form.Check.Label>
                                </Form.Check>
                                <Form.Check className='d-flex'>
                                    <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px' }}>
                                        <Form.Check.Input
                                            type="radio"
                                            name="requireToSelectPlan"
                                            onChange={() => handleChangeData(false, "requireToSelectPlan")}
                                        ></Form.Check.Input>
                                        <><h5 className='fw-100 my-1'>No (Go to question 13)</h5>
                                        </>
                                    </Form.Check.Label>
                                </Form.Check>
                            </Form.Group>
                            {errors.requireToSelectPlan && <Form.Text className="text-danger"> <span className="star">*</span> {errors.requireToSelectPlan} </Form.Text>}
                        </Col>

                        <Col sm={12} className="my-1">
                            <h5>To avoid repaying more than you need to, tick the correct student loan or loans that you have - use the guidance on the right to help you. </h5>
                            <p><h5 className='fw-100'>Please tick all that apply </h5></p>
                            <Form.Group>
                                <Form.Check className='d-flex'>
                                    <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px', fontWeight: '100' }}>
                                        <Form.Check.Input
                                            type="radio"
                                            name="selectedPlan"
                                            onChange={(e) =>
                                                setFormData(prevState => ({
                                                    ...prevState,
                                                    selectedPlan: 0,
                                                }))
                                            }
                                        ></Form.Check.Input>
                                        <><h5 className='fw-100 my-1'>Plan 1</h5>
                                        </>
                                    </Form.Check.Label>
                                </Form.Check>
                                <Form.Check className='d-flex'>
                                    <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px', fontWeight: '100' }}>
                                        <Form.Check.Input
                                            type="radio"
                                            name="selectedPlan"
                                            onChange={(e) =>
                                                setFormData(prevState => ({
                                                    ...prevState,
                                                    selectedPlan: 1,
                                                }))
                                            }
                                        ></Form.Check.Input>
                                        <><h5 className='fw-100 my-1'>Plan 2</h5>
                                        </>
                                    </Form.Check.Label>
                                </Form.Check>
                                <Form.Check className='d-flex'>
                                    <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px', fontWeight: '100' }}>
                                        <Form.Check.Input
                                            type="radio"
                                            name="selectedPlan"
                                            onChange={(e) =>
                                                setFormData(prevState => ({
                                                    ...prevState,
                                                    selectedPlan: 2,
                                                }))
                                            }
                                        ></Form.Check.Input>
                                        <><h5 className='fw-100 my-1'>Plan 4</h5>
                                        </>
                                    </Form.Check.Label>
                                </Form.Check>
                                <Form.Check className='d-flex'>
                                    <Form.Check.Label style={{ textAlign: 'left', paddingLeft: '24px', fontWeight: '100' }}>
                                        <Form.Check.Input
                                            type="radio"
                                            name="selectedPlan"
                                            onChange={(e) =>
                                                setFormData(prevState => ({
                                                    ...prevState,
                                                    selectedPlan: 3,
                                                }))
                                            }
                                        ></Form.Check.Input>
                                        <><h5 className='fw-100 my-1'>Postgraduate loan (England and Wales only)</h5>
                                        </>
                                    </Form.Check.Label>
                                </Form.Check>
                            </Form.Group>
                            {errors.selectedPlan && <Form.Text className="text-danger"> <span className="star">*</span> {errors.selectedPlan} </Form.Text>}
                        </Col>
                    </Col>
                    <Col sm={6} xs={12} >
                        <Col sm={12} className="my-1">
                            <p>
                                <h5 className='fw-100'>Employees, for more information about the type of loan you have or to check your balance, go to{' '}
                                    <a href='https://www.gov.uk/sign-in-to-manage-your-student-loan-balance' rel="noreferrer" target="_blank" >www.gov.uk/sign-in-to-manage-your-student-loan-balance</a>
                                </h5>
                            </p>
                            <p>
                                <h5 className='fw-100'>
                                    Employers, for guidance on student loans and which plan or loan type to use if your employee has selected more than one, go to{' '}
                                    <a href='https://www.gov.uk/guidance/special-rules-for-student-loans' rel="noreferrer" target="_blank" >www.gov.uk/guidance/special-rules-for-student-loans</a>
                                </h5>
                            </p>
                        </Col>
                        <Table className='induction-table'>
                            <tbody>
                                <tr >
                                    <td style={{ border: "1px solid black" }}>
                                        <p><h5>You have Plan 1 if any of the following apply:</h5></p>
                                        <div>
                                            <ul>
                                                <li className='text-left'><h5 className='fw-100'>You lived in Northern Ireland when you started your course</h5></li>
                                                <li className='text-left'><h5 className='fw-100'>You lived in England or Wales and started your course before 1 September 2012</h5></li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid black" }}>
                                        <p><h5>You have Plan 2 if:</h5></p>
                                        <p><h5 className='fw-100'>You lived in England or Wales and started your course on or after 1 September 2012.</h5></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid black" }}>
                                        <p><h5>You have Plan 4 if: </h5></p>
                                        <p><h5 className='fw-100'>You lived in Scotland and applied through the Students Award Agency Scotland (SAAS) when you started your course. </h5></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid black" }}>
                                        <p><h5><strong>You have a postgraduate loan if any of the following apply:</strong></h5></p>
                                        <div>
                                            <ul>
                                                <li className='text-left'><h5 className='fw-100'>You lived in England and started your postgraduate master's course on or after 1 August 2016</h5></li>
                                                <li className='text-left'><h5 className='fw-100'>You lived in Wales and started your postgraduate master's course on or after 1 August 2017</h5></li>
                                                <li className='text-left'><h5 className='fw-100'>You lived in England or Wales and started your postgraduate doctoral course on or after 1 August 2018</h5></li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </>}
            <hr />

            <Row>
                <Col sm={12} className="d-flex justify-content-between mt-3">
                    <Button className="btn-lg btn-shadow btn-step" variamt="danger" onClick={handleBack} >Back</Button>
                    <Button className="btn-lg btn-shadow btn-step" variant="success" onClick={handleSubmit} >Next Step</Button>
                </Col>
            </Row>
        </>

    );
};

export default StepFour;

